import { updatesData } from "@/mocks/homeData";

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">📡 实时快讯</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">最新51吃瓜爆料动态，滚动追踪全网热点</p>

        <div className="relative pl-6 before:absolute before:left-2.5 before:top-1 before:bottom-1 before:w-px before:bg-background-300/60">
          {updatesData.map((item, i) => (
            <div key={i} className="relative pb-5 last:pb-0">
              <div className={`absolute -left-[22px] top-1 w-2.5 h-2.5 rounded-full border-2 border-background-100 ${
                item.hot ? "bg-accent-500" : "bg-secondary-400"
              }`}></div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-3">
                <span className={`text-xs font-mono whitespace-nowrap ${
                  item.hot ? "text-accent-600 font-semibold" : "text-foreground-500"
                }`}>
                  {item.time}
                </span>
                <p className="text-sm text-foreground-800 leading-relaxed flex-1">
                  {item.content}
                  {item.hot && (
                    <span className="inline-flex items-center gap-0.5 ml-2 px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-xs font-medium whitespace-nowrap">
                      <i className="ri-fire-line text-[10px]"></i> 热
                    </span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}